const initialState = {
  count: 0,
  notifications: [],
};

const notificationReducer = (state = initialState, action) => {
  console.log("====================================");
  console.log("Notification reducer called", action.payload);
  console.log("====================================");
  switch (action.type) {
    case "ADD_NOTIFICATION":
      return {
        ...state,
        count: state.count + 1,
        notifications: [...state.notifications, action.payload],
      };

    case "CLEAR_NOTIFICATIONS":
      return {
        ...state,
        count: 0,
        notifications: [],
      };
    default:
      return state;
  }
};

export default notificationReducer;
